import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonList } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { analytics } from 'app/utils/segment';
import { useAppNavigate } from 'utils/url/useAppNavigate';
/** Represents the component for viewing the user. */
export const ConversationsTableRowMenuUser = ({ user, isAssignee, }) => {
    const navigate = useAppNavigate();
    const label = `View ${isAssignee ? 'agent' : 'contact'}`;
    const handleClick = useCallback(() => {
        navigate({
            path: '/contacts/user/:id',
            params: { path: { id: user.id } },
        });
        if (isAssignee) {
            analytics.conversationsViewAgentClicked();
        }
        else {
            analytics.conversationsViewContactClicked();
        }
    }, [navigate, user.id, isAssignee]);
    return _jsx(ButtonList.Item, Object.assign({ onClick: handleClick }, { children: label }));
};
